<template><v-dialog
  v-model="dialog"
  persistent
  max-width="600px"
>
  <v-card class="pa-0">
     <v-toolbar color="primary darken-1" dark dense>
        {{ this.isEdit ? $t("portfolio.Feedback.edit") : $t("portfolio.Feedback.add") }}
        <v-spacer></v-spacer>

        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

    <v-card-text>
      <v-form
        ref="feedbackForm"
        v-model="formValid"
      >
        <v-container>
          <v-row>
            <v-col cols="12" class="mt-6">
              <v-textarea 
                v-model="feedback.feedbackText"
                :label="$t('portfolio.Feedback.text')"
                outlined
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions > 
       <v-btn
        color="primary"
        :disabled="!formValid"
        @click="submitFeedback"
      >
        {{ $t('save') }}
      </v-btn>
      <v-btn color="red"
        text
        @click="closeDialog"
      >{{ $t('cancel') }}</v-btn>
    
    </v-card-actions>
  </v-card>
</v-dialog></template>

<script>
export default {
  props: {
    sourceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      isEdit: false,
      formValid: false,
      feedback: {
        sourceGuid: "",
        feedbackText: "",
      },
    };
  },
  methods: {
    showDialog(sourceGuid) {
      this.clearForm();
      this.feedback.sourceGuid = sourceGuid;
      this.isEdit = false;
      this.dialog = true;
      this.$refs.feedbackForm.resetValidation();
    },
    showEditDialog(existingFeedback) {
      this.feedback = { ...existingFeedback };
      this.isEdit = true;
      this.dialog = true;
      this.$refs.feedbackForm.resetValidation();
    },
    closeDialog() {
      this.dialog = false;
    },
    clearForm() {
      this.feedback = {
        sourceGuid: "",
        feedbackText: "",
      };
    },
    submitFeedback() {
      this.$refs.feedbackForm.validate();
      if (!this.formValid) return;

      if (this.isEdit) {
        this.axios.post("Feedback/Update", { feedbackGuid: this.feedback.feedbackGuid, feedbackText: this.feedback.feedbackText })
          .then((response) => {
            this.$emit("edit", this.feedback);
          })
          .catch((error) => {
            this.$emit("error", error.message);
          });
      } else {
        this.axios.post("Feedback/Create", { ...this.feedback, sourceType: this.sourceType })
          .then((response) => {
            this.$emit("add", response.data);
          })
          .catch((error) => {
            this.$emit("error", error.message);
          });
      }
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.headline {
  font-weight: bold;
}

.v-card {
  padding: 16px;
}
</style>
